import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {KnowledgeArticleSimpleResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {PublishedDraftPills} from 'src/design/atoms/pillPresets';
import {PublishedStateDataOptions} from 'src/shared/constants/columnFilterData';
import {formatUtcShortDate} from 'src/shared/utils/formatters';

export const useKnowledgeArticleColumns = () => {
  const columns = useMemo<MRT_ColumnDef<KnowledgeArticleSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'published',
        header: 'Status',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: PublishedStateDataOptions,
        },
        size: 120,
        Cell: ({cell}) => {
          const published = cell.getValue<boolean>();
          return <Pill {...PublishedDraftPills(published)} />;
        },
      },
      {
        accessorKey: 'title',
        header: 'Title',
      },
      {
        accessorKey: 'tags',
        header: 'Tags',
      },
      {
        accessorKey: 'isGlobal',
        header: 'Scope',
        enableColumnFilter: false,
        enableSorting: false,
        size: 120,
        Cell: ({cell}) =>
          cell.getValue<boolean>() ? (
            <Pill text="Global" color="blue" />
          ) : (
            <Pill text="Instance" color="gray" />
          ),
      },
      {
        accessorKey: 'updatedAt',
        header: 'Updated',
        enableColumnFilter: false,
        Cell: ({cell}) => formatUtcShortDate(cell.getValue<string>()),
      },
    ],
    []
  );

  return columns;
};
